<template>
  <div>
    <Head :title="form.product_name"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/dergesat">Dërgesat</Link>
      <span class="text-indigo-400 font-medium">/ </span>
      <Link class="text-indigo-400 font-medium" :href="`/dergesat/${order.data.id}`">{{ order.data.id }}</Link>
      <span class="text-indigo-400 font-medium">/ </span>
      Edito

    </h1>
    <div class=" bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input  v-model="form.business_id" :error="form.errors.business_id" class="pb-8 pr-6 w-full lg:w-1/4" label="Biznesi shitës" disabled>
            <option :key="order.data.business_id" :value="order.data.business_id" >{{ order.data.business_name }}</option>
          </select-input>

<!--          <select-input v-model="form.location_id" :error="form.errors.location_id" class="pb-8 pr-6 w-full lg:w-1/4" label="Pika marrëse">-->
<!--            <option v-for="location in form.locations"  :key="location.id" :value="location.id">{{ location.name }}</option>-->
<!--          </select-input>-->

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="form-label">Pika marrëse:</label>
            <select v-model="form.location_id" :error="form.errors.location_id" class="form-select focus:ring-0 hover:border-indigo-500" >
              <option v-for="location in selectedLocations" :key="location.id" :value="location.id">{{ location.name }}</option>
            </select>
          </div>

          <text-input v-model="form.custom_id" :error="form.errors.custom_id" class="pb-8 pr-6 w-full lg:w-1/4" label="ID e sistemit tuaj" />



        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full">Të dhënat e dërgesës</h3>
          <select-input v-model="form.package_size_id" :error="form.errors.package_size_id" class="pb-8 pr-6 w-full lg:w-1/4" label="Madhësia e pakos">
            <option v-for="packageSize in packageSizes"  :key="packageSize.id" :value="packageSize.id">{{ packageSize.name }}  {{ packageSize.description }}</option>
          </select-input>

          <select-input v-model="form.fragile" :error="form.errors.fragile" class="pb-8 pr-6 w-full lg:w-1/4" label="A është pako fragjile(e dëmtueshme)">
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <select-input v-model="form.openable" :error="form.errors.openable" class="pb-8 pr-6 w-full lg:w-1/4" label="A mund të hapet pako">
            <option :value="true">Po</option>
            <option :value="false">Jo</option>
          </select-input>

          <text-input v-model="form.quantity" :error="form.errors.quantity" class="pb-8 pr-6 w-full lg:w-1/4" label="Sasia e produktit" />

          <text-input v-model="form.product_name" :error="form.errors.product_name" class="pb-8 pr-6 w-full lg:w-1/4" label="Emri i produktit" />
          <text-input v-model="form.product_description" :error="form.errors.product_description" class="pb-8 pr-6 w-full lg:w-1/4" label="Përshkrimi i produktit(opsionale)" />
          <text-input v-model="form.product_price" :error="form.errors.product_price" class="pb-8 pr-6 w-full lg:w-1/4" label="Çmimi i produktit" />


          <div class="flex flex-wrap w-full">
            <select-input :disabled="!is_change_show" v-model="form.is_change" :error="form.errors.is_change" class="pb-8 pr-6 w-full lg:w-1/4"
                          label="A është ndërrim?"
            >
              <option :value="true">Po</option>
              <option :value="false">Jo</option>
            </select-input>

            <select-input :disabled="!is_cash_show" v-model="form.is_cash" :error="form.errors.is_cash" class="pb-8 pr-6 w-full lg:w-1/4"
                          label="A është kthim i mjeteve?"
            >
              <option :value="true">Po</option>
              <option :value="false">Jo</option>
            </select-input>

            <select-input v-if="has_product_show" v-model="form.has_product" :error="form.errors.has_product" class="pb-8 pr-6 w-full lg:w-1/4"
                          label="A ka produkt për t'u kthyer?"
            >
              <option :value="true">Po</option>
              <option :value="false">Jo</option>
            </select-input>

            <text-input v-if="has_product_show || this.form.is_change" v-model="form.return_id" :error="form.errors.return_id" class="pb-8 pr-6 w-full lg:w-1/4"
                        label="ID e dërgesës për kthim/ndërrim"
            />

          </div>


        </div>
        <hr>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <h3 class="text-sm font-bold pb-8 pr-6 w-full lg:w-full">Të dhënat e klientit</h3>
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/4" label="Emri & Mbiemri" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/4" label="Telefoni" />
          <text-input v-model="form.second_phone" :error="form.errors.second_phone" class="pb-8 pr-6 w-full lg:w-1/4" label="Telefoni (sekondar)" />

          <select-input  v-model="form.country_id" :error="form.errors.country_id" class="pb-8 pr-6 w-full lg:w-1/4" label="Shteti">
            <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }} </option>
          </select-input>

<!--          <select-input v-model="form.city_id" :error="form.errors.city_id" class="pb-8 pr-6 w-full lg:w-1/4" label="Qyteti">-->
<!--            <option v-for="city in selectedCities" :key="city.id" :value="city.id">{{ city.name }} </option>-->
<!--          </select-input>-->

          <div class="pb-8 pr-6 w-full lg:w-1/4">
            <label class="form-label">Qyteti:</label>
            <select v-model="form.city_id" :error="form.errors.city_id" class="form-select focus:ring-0 hover:border-indigo-500" >
              <option v-for="city in selectedCities" :key="city.id" :value="city.id">{{ city.name }}</option>
            </select>
          </div>

          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-2/4" label="Adresa" />

          <select-input v-model="form.area_type" :error="form.errors.area_type" class="pb-8 pr-6 w-full lg:w-1/4"
                        label="Qytet/Fshat"
          >
            <option :value="null" selected>Zgjedh</option>
            <option value="qytet">Qytet</option>
            <option value="fshat">Fshat</option>
          </select-input>

          <textarea-input v-model="form.additional_info" :error="form.errors.additional_info" class="pb-8 pr-6 w-full lg:w-full" label="Informata shtesë" />


        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!order.data.deleted_at && order.data.status_id === 1" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Fshij</button>
          <loading-button id="show-modal" @click="showModal = true" :loading="form.processing" class="btn-indigo ml-auto" type="button">Edito</loading-button>

          <Teleport to="body">
            <!-- use the modal component, pass in the prop -->
            <modal :show="showModal" @close="showModal = false">
              <template #header>
                <h3>Duhet të tregohet çka është edituar dhe të jipet një koment për editim të dërgesës.</h3>
              </template>

              <template #body>

                <div class="flex flex-wrap">
                  <textarea-input :required="true" v-model="form.update_description" :error="form.errors.update_description" class="w-full pb-4" label="Përshkrimi (çka është edituar?)" />
                  <textarea-input :required="true" v-model="form.update_comment" :error="form.errors.update_comment" class="w-full pb-4" label="Komenti (Arsyeja)" />
                  <file-input v-model="form.update_document" :error="form.errors.update_document" class="w-full pb-4" type="file" accept="image/*" label="Dëshmi (nëse ka)" />
                </div>
              </template>

              <template #footer>
                <div class="flex flex-wrap">
                <loading-button class="btn-indigo bg-red-500"
                        @click = "showModal = false"
                >Anulo</loading-button>
                <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="button" @click="update(); showModal = false">Edito</loading-button>
                </div>
              </template>
            </modal>
          </Teleport>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import axios from 'axios'
import {computed} from 'vue'
import Modal from '@/Shared/Modal'
import FileInput from '@/Shared/FileInput'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    Modal,
    FileInput
  },
  layout: Layout,
  props: {
    countries: Array,
    cities: Array,
    packageSizes: Array,
    locations: Array,
    order: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        id: this.order.data.id,
        custom_id: this.order.data.custom_id,
        business_id: this.order.data.business_id,
        location_id: this.order.data.location_id,
        package_size_id: this.order.data.package_size_id,
        fragile: this.order.data.fragile,
        openable: this.order.data.openable,
        quantity: this.order.data.quantity,
        product_name: this.order.data.product_name,
        product_description: this.order.data.product_description,
        product_price: this.order.data.product_price,
        name: this.order.data.name,
        phone: this.order.data.phone,
        second_phone: this.order.data.second_phone,
        country_id: this.order.data.country_id,
        city_id: this.order.data.city_id,
        address: this.order.data.address,
        area_type: this.order.data.area_type,
        additional_info: this.order.data.additional_info,

        is_change: this.order.data.is_change,
        is_cash: this.order.data.is_cash,
        has_product: this.order.data.has_product,

        update_description: null,
        update_comment: null,
        update_document: null,

        return_id: this.order.data.return_id
      }),
      selectedLocations: this.locations,
      selectedCities: this.cities,
      showModal: false,
      is_change_show: this.order.data.is_change || (this.order.data.is_change === false && this.order.data.is_cash === false),
      is_cash_show: this.order.data.is_cash  || (this.order.data.is_change === false && this.order.data.is_cash === false),
      has_product_show: this.order.data.is_cash
    }
  },
  methods: {
    update() {
      this.form.post(`/dergesat/${this.order.data.id}`)
    },
    destroy() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.delete(`/dergesat/${this.order.data.id}`)
      }
    },
    getLocations(){
      let self = this
      self.selectedLocations = []
      axios.get('/ajax/list/locations',{
        params: {
          business_id: this.form.business_id,
        }
      }).then(function (result){
        self.selectedLocations = result.data.locations;
        self.form.location_id = result.data.locations[0].id
      });
    },
    getCities(){
      let self = this
      self.form.selectedCities = []
      axios.get('/ajax/list/cities',{
        params: {
          country_id: this.form.country_id,
        }
      }).then(function (result){
        self.selectedCities = result.data.cities;
        self.form.city_id = result.data.cities[0].id
      });
    },
  },
  watch: {
    'form.business_id'(businessId) {
      this.getLocations()
    },
    'form.country_id'(countryId){
      this.getCities()
    },
    'form.is_change'(newValue){
      if(newValue === true){
        this.is_cash_show = false;
        this.form.is_cash = false;
        this.form.has_product = true
        this.has_product_show = false;
      } else {
        this.is_cash_show = true;
        this.form.has_product = false;
      }
    },
    'form.is_cash'(newValue){
      if(newValue === true){
        this.has_product_show = true;
        this.is_change_show = false;
        this.form.is_change = false
      } else {
        this.form.has_product = false;
        this.is_change_show = true;
        this.form.is_change = false;
        this.has_product_show = false;
      }
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>
